// removed by extract-text-webpack-plugin
module.exports = {"ripple":"_3cRG38pNXY302aP-uw-iIX","rippleWrapper":"_2AWhQ6mkBwjnOta75XQSFv","rippleRestarting":"y45XADMV3QScYjXJkvNxS","rippleActive":"_1QiQfZHkjJBnbSuhZq66jr"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-toolbox/lib/ripple/theme.scss
 ** module id = 989
 ** module chunks = 0
 **/